import { IGetAllChecklistServicoAmbienteUseCase } from "../../../presentation/useCases/read/get_all_checklist_servico_ambiente_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";
import { ChecklistServicoAmbienteModel } from "../../models/checklist_servico_ambiente";

/**
 * GetAllChecklistServicoAmbienteUseCase
 */

export class GetAllChecklistServicoAmbienteUseCase
  extends BasePaginatedUseCase<ChecklistServicoAmbienteModel>
  implements IGetAllChecklistServicoAmbienteUseCase {
  constructor(private readonly repository: IObrasRepository) {
    super();
  }

  async execute(
    idChecklistServico: number,
    descricao?: string,
    page?: number,
    rowsPerPage?: number,
  ): Promise<void> {
    const response = await this.repository.getAllChecklistServicoAmbientes(
      idChecklistServico,
      descricao,
      page,
      rowsPerPage,
    );

    this._items = response.items;
    this._totalPages = response.totalPages;
    this._totalItems = response.totalItems;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;

  }
}

